import React from 'react';

import DocumentStatusBar from '../../chart/DocumentStatusBar';

const NextCheckinInProgress = props => {
    if (!props.documents) {
        return null;
    }

    const IN_PROGRESS_STATES = ['Not Started', 'Started', 'Revision Required'];

    let statusKeys = Object.keys(props.documents);
    let totalCount = 0;
    let max = -1;
    IN_PROGRESS_STATES.forEach(key => {
        let bar = props.documents[key];
        totalCount += bar.count;
        if (bar.count > max) {
            max = bar.count;
        }
    });

    statusKeys.forEach(key => {
        let bar = props.documents[key];
        let nValue = (bar.count / max) * 100;
        bar.normalized = nValue;
    });

    const docs = props.documents;

    return (
        <div className="NextCheckinInProgress">
            <div className="bars">
                <div>
                    Not Started
                    <DocumentStatusBar percentage={docs['Not Started'].normalized || 0} count={docs['Not Started'].count || 0} criticality={props.documents['Not Started'].criticality} />
                </div>
                <div>
                    Started
                    <DocumentStatusBar percentage={docs['Started'].normalized || 0} count={docs['Started'].count || 0} criticality={props.documents['Started'].criticality} />
                </div>
                <div>
                    Revision Required
                    <DocumentStatusBar percentage={docs['Revision Required'].normalized || 0} count={docs['Revision Required'].count || 0} criticality={props.documents['Revision Required'].criticality} />
                </div>
            </div>
            <div className="totals">
                <div className="count">{totalCount}</div>
                <div className="label">In Progress</div>
            </div>
        </div>
    );
};

export default NextCheckinInProgress;
